import EmptyScreen from './EmptyScreen.component';

export default EmptyScreen;